import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import AttachmentMixin from '@/_mixins/attachment'

@Component({
    mixins: [AttachmentMixin],
})
export default class ProjectAvatar extends Mixins<MixinInterface>(AttachmentMixin) {
    @Prop() item!: any
    @Prop() size!: any
    @Prop() icon!: any

    get abr() {
        return this.item ? this.getAbbrev(this.item.attributes.name) : ''
    }

    get avatar() {
        return this.item?.attributes?.avatarFileId
            ? this.getPreview(this.item.attributes.avatarFileId)
            : null
    }
}
